<template>
  <div class="jumbotron jumbotron-image">
    <h1 class="center-text-vh text-white">{{h1}}</h1>
  </div>
</template>
<script>
export default {
    props:{
        h1:String
    }
}
</script>